import moment from 'moment';

export const ISO_DATE = 'YYYY-MM-DD';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const DEFAULT_TIME_FORMAT = 'hh:mm:ss A';
export const DEFAULT_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm:ss A';
export const DEFAULT_FILE_DATE_FORMAT = 'MM-DD-YYYY';

export const DOB_INPUT_FORMATS = [
  'MM/dd/yyyy',
  'MM-dd-yyyy',
  'MM.dd.yyyy',
  'yyyy-MM-dd',
  'yyyy/MM/dd',
  'yyyy.MM.dd',
];

export type DateInput = string | Date | null | undefined;

export function formatIsoDate(value: DateInput, format: string): string {
  if (!value) return '';
  const parsed =
    value instanceof Date ? moment(value) : moment(value, ISO_DATE, true);
  return parsed.isValid() ? parsed.format(format) : '';
}

export function formatUtcDateTime(value: DateInput, format: string): string {
  if (!value) return '';
  const parsed = moment.utc(value);
  return parsed.isValid() ? parsed.local().format(format) : '';
}

export function formatTodayForFile(
  format: string,
  now: () => moment.Moment = moment,
): string {
  return now().format(format);
}
